"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBleTimeoutInfo = void 0;
var parseBleTimeoutInfo = function (dataView) {
    return {
        timeout: dataView === null || dataView === void 0 ? void 0 : dataView.getUint16(0),
    };
};
exports.parseBleTimeoutInfo = parseBleTimeoutInfo;
